<template>
  <div class="card6-container">

    <!--    <b-collapse :visible="filter" id="filter">-->
    <!--      <app-filter-modal @close="closeFilter" @apply="applyFilter"></app-filter-modal>-->
    <!--    </b-collapse>-->
    <div class="card6">
      <div class="card6-list">
        <div class="list-header">
          <div>
            <app-list-statistics :list="transactionsStrongbox"></app-list-statistics>
          </div>
          <div class="ml-auto action-buttons">
            <button class="no-fill" @click="toggleFilter()">
              <span :class="{'icon-equalizer':true, 'active': filter}"></span>
            </button>
            <!--            <button class="no-fill" @click="toggleCards()">-->
            <!--              <span v-if="cardsMode" class="icon-view_comfy"></span>-->
            <!--              <span v-if="!cardsMode" class="icon-view_stream"></span>-->
            <!--            </button>-->
            <button class="no-fill" @click="refresh()">
              <span class="icon-sync"></span>
            </button>
          </div>
        </div>
        <app-loader :loading="loading">
          <app-no-results v-if="!loading && transactionsIsEmpty()"/>
          <cards-list v-if="!transactionsIsEmpty() && cardsMode"
                      :transactions-strongbox="transactionsStrongbox"/>

          <!--          <strongbox-table v-if="!transactionsIsEmpty() && !cardsMode"-->
          <!--                           :transactions-strongbox="transactionsStrongbox"/>-->
          <app-pagination v-show="!transactionsIsEmpty()" :state="transactionsStrongbox"
                          :update="updateStrongbox"
                          :append="appendStrongbox"
                          @loading="paginateLoading"
                          :scroll="false"
                          :filter="filterSelectStrongbox"
                          ref="pagination"/>

        </app-loader>
      </div>
    </div>
    <div v-show="filter" id="filter">
      <app-filter-modal @close="closeFilter" @apply="applyFilter"></app-filter-modal>
    </div>
  </div>
</template>
<script>
import AppLoader from '/src/components/loader'
import AppNoResults from '/src/components/NoResults'
import AppPagination from '/src/components/pagination'
import AppFilterModal from './filter-components/filter-modal'
// import StrongboxTable from './table-components/strongbox-table'
import CardsList from './card-components/cards-list'
import {mapActions, mapState} from 'vuex'
import listModeMixin from '/src/features/transactions/components/list-components/mixins/list-mode'
import settingsMixin from './mixins/settings'
import filterMixin from './mixins/filter'
import AppListStatistics from './list-statistics'

export default {
  components: {
    AppLoader,
    AppNoResults,
    AppPagination,
    AppFilterModal,
    AppListStatistics,
    // StrongboxTable,
    CardsList
  },

  mixins: [
    listModeMixin,
    settingsMixin,
    filterMixin
  ],

  data() {
    return {
      loading: false,
      filter: true
    }
  },
  computed: {
    ...mapState('transactions', ['transactionsStrongbox']),
    ...mapState('filters', ['filterSelectStrongbox'])
  },

  methods: {
    ...mapActions('transactions', ['updateStrongbox', 'appendStrongbox']),
    transactionsIsEmpty() {
      return !(this.transactionsStrongbox && this.transactionsStrongbox.data.length)
    },
    paginateLoading() {
      this.loading = true
    },
    refresh() {
      this.$refs.pagination.refreshState()
    }
  },

  watch: {
    'transactionsStrongbox': {
      handler: function () {
        this.loading = false
      },
      deep: true
    }
  }
}
</script>
